import EULA from "views/EULAView";

export default function Page() {
  return (
    <>
      <EULA />
    </>
  );
}
